import { $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { CONFIGURATION_PROFILE_SERVICE_NAME, ConfigurationProfileService } from '../../../services/configuration-profile'
import { ConfigurationProfileCreateEditController } from './configuration-profile-create-edit.directive.controller'

import { Enums } from '../../../models/common'

//#region Asset Imports

import * as TEMPLATE from './configuration-profile-create-edit.tpl.html'

//#endregion

// #region Setup

export class ConfigurationProfileCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        CONFIGURATION_PROFILE_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            userSession: UserSessionService,
            configurationProfileService: ConfigurationProfileService
        ) => new ConfigurationProfileCreateEditController(
            $scope,
            $q,
            $timeout,
            userSession,
            Enums.ReferenceType.IdLocation,
            Enums.SimaxModuleName.Location,
            configurationProfileService
        )]

    template = TEMPLATE
}

// #endregion